const USER_ROLES = {
  PBX_USER: "Pbx User",
  PBX_ADMIN: "Pbx Admin",
};

const PBX_ROLES = [USER_ROLES.PBX_USER, USER_ROLES.PBX_ADMIN];

export { USER_ROLES, PBX_ROLES };
